import { useEffect, useState } from "react";

// True on phones / small tablets (< 768px). Used where the layout itself has
// to change (sidebar -> drawer, admin table -> cards), not just its sizing —
// plain sizing tweaks live in responsive.css.
export const MOBILE_QUERY = "(max-width: 767px)";

const read = (query) =>
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(query).matches
    : false;

export default function useIsMobile(query = MOBILE_QUERY) {
  const [isMobile, setIsMobile] = useState(() => read(query));

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const mq = window.matchMedia(query);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, [query]);

  return isMobile;
}
